import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { inject, observer } from 'mobx-react'
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { toast } from "../../libs/react-mpk/services";
import { Logo } from '../../libs/react-mpk/components'
import {Modal} from '../../libs/react-mpk/components'
import renderHTML from 'react-render-html'


import { getUploadAggrement } from "./Login.service"
import jwt_decode from "jwt-decode";
import fs from "fs";
import path from "path";


import { LoginService, ForgotService } from './Login.service';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://pajakku.com/">
        Pajakku.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

function SignIn({authStore, envStore, navigationStore}) {
  const [showPassword, setShowPassword] = React.useState(false);
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [errormsg, setErrormsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  
  React.useEffect(()=>{
  },[])
  const handleSubmit = async () => {
    try {
      setLoading(true)
      let response =  await ForgotService({
        email: email
      })
      toast.success("Link Reset Password segera dikirim ke email anda, Silahkan cek email!")
      await navigationStore.redirectTo('/general/login')
      setLoading(false)
    } catch (error) {
        toast.error(error.message)
        setLoading(false)
      // setErrormsg('format email salah');
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            paddingTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}> */}
            {/* <LockOutlinedIcon /> */}
          {/* </Avatar> */}
          <Box sx={{ m: 2 }}>
            <Logo />
          </Box>
          <Typography component="h1" variant="h6">
            Forgot Password
          </Typography>
          <Box component="form" noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e)=>{
                setEmail(e.target.value)
              }}
            />
            {errormsg &&
              <Typography style={{color: 'red', textAlign: 'center'}}>
                {errormsg}
              </Typography>
            }
            
              <Button
                style={{
                  backgroundColor:"#c34528"
                }}
                // type="submit"
                onClick={()=> handleSubmit()}
                fullWidth
                disabled={loading}
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                {loading ?
                <CircularProgress
                  style={{
                    color: 'white',
                    width: 25,
                    height: 25,
                  }}
                  // sx={{ mt: 3, mb: 2 }}
                />
                :
                'SEND'
                }
              </Button>
            
            <Grid container>
              <Grid item xs>
                <Link onClick={()=>navigationStore.redirectTo('/general/login')} variant="body2">
                  Sign In
                </Link>
              </Grid>
              {/* <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid> */}
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}

export default inject('authStore', 'envStore', 'navigationStore')(observer(SignIn))